// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"2a7cd3cd","453":"a1b9ffa6"}[chunkId] + ".chunk.js";
};